<template>
  <filter-summary
    icon="calendar"
    title="期間"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>当期間：</div>
    <div style="text-align:right">{{ baseSummary }}</div>
    <div>前期間：</div>
    <div style="text-align:right">{{ compareSummary }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'
import { toHumanFriendlyFormat } from '@/util/date'

/**
 * 「期間」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    base: {
      dateFrom: {
        type: String,
      },
      dateTo: {
        type: String,
      },
      errors: {
        type: Array,
      },
    },
    compare: {
      dateFrom: {
        type: String,
      },
      dateTo: {
        type: String,
      },
      errors: {
        type: Array,
      },
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    baseSummary() {
      return this.summary(this.base)
    },
    compareSummary() {
      return this.summary(this.compare)
    },
  },
  methods: {
    summary(term) {
      if (term.dateFrom && term.dateTo) {
        return (
          toHumanFriendlyFormat(term.dateFrom) +
          ' ～ ' +
          toHumanFriendlyFormat(term.dateTo)
        )
      } else {
        return ''
      }
    },
  },
}
</script>
